import * as React from "react";

const PaginationLeft: React.FC = () => {
    return <svg width="8px" height="15px" viewBox="0 0 8 15" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" fill="currentColor">
    
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g fill="currentColor" fillRule="nonzero">
            <g>
                <path d="M6.26489132,14.6813596 L0.274686921,8.203603 C0.0915482547,8.00650021 0,7.75356949 0,7.50042548 C0,7.24736665 0.0915904114,6.99413745 0.27468756,6.79724795 L6.26489196,0.319491376 C6.64686689,-0.0906955128 7.28251493,-0.107955273 7.68521049,0.279538107 C8.0907529,0.668416586 8.10506892,1.31853638 7.72445449,1.72595307 L2.34959653,7.50053212 L7.72445449,13.2751112 C8.10513151,13.6826137 8.09073183,14.3298775 7.68521049,14.7215261 C7.28628221,15.1075278 6.65000628,15.0904813 6.26489196,14.6813596 L6.26489132,14.6813596 Z"></path>
            </g>
        </g>
    </g>
</svg>;
};

export default React.memo(PaginationLeft);
